'use client';

import { usePathname } from 'next/navigation';

import GenerateImageSidebar from './image-creator/components/sidebar';
import ModelTrainingSidebar from './model-trainer/components/sidebar';

export default function GeneratorLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  return (
    <div className='flex h-full'>
      {/* Sidebar */}
      <aside className='hidden md:block w-96 border-r border-white/20 px-6 py-8 overflow-y-auto'>
        {pathname === '/image-creator' && <GenerateImageSidebar />}
        {pathname === '/model-trainer' && <ModelTrainingSidebar />}
      </aside>

      {/* Main content */}
      <main className='flex-1 overflow-y-auto'>{children}</main>
    </div>
  );
}
